import { render, staticRenderFns } from "./DebtorAssignmentInformation.vue?vue&type=template&id=4117c2a4&"
import script from "./DebtorAssignmentInformation.vue?vue&type=script&lang=js&"
export * from "./DebtorAssignmentInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports